import React, { useState } from "react";
import { Box, Typography, ClickAwayListener } from "@mui/material";
import { motion } from "framer-motion";

export const ProductInfoBox = ({ data, moreData, show, isNight = false }) => {
  const [expanded, setExpanded] = useState(false);
  const rowsToShow = expanded ? data.rows : data.rows.slice(0, 3);

  const cardBaseStyles = {
    backgroundColor: isNight ? "#848ba1" : "#fff",
    color: isNight ? "#eef2f7" : "#000",
    boxShadow: "#0000001a 0px 0px 50px 0px",
    borderRadius: "0px",
    overflow: "hidden",
    fontSize: "calc(0.63rem + var(--large-screen-font-bump))",
    cursor: expanded ? "default" : "pointer",
    transition: "color 0.35s ease, background-color 0.35s ease",
  };

  return (
    <>
      {!expanded ? (
        <motion.div
          layoutId="info-card"
          initial={{ opacity: 0 }}
          animate={{ opacity: show ? 1 : 0 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
          style={{
            ...cardBaseStyles,
            width: 180,
            height: 100,
            padding: "15px",
            right: "3vh",
            top: "3vh",
            position: "absolute",
          }}
          onClick={() => setExpanded(true)}
        >
          <Typography
            fontWeight="bold"
            textAlign={"start"}
            sx={{ fontSize: "calc(0.63rem + var(--large-screen-font-bump))", paddingBottom: "5px" }}
          >
            {data.title}
          </Typography>
          {rowsToShow.map((row, i) => (
            <Box key={i} display="flex" justifyContent="space-between" mt={0.5}>
              <span>{row.label}</span> <span>{row.value}</span>
            </Box>
          ))}
          {data.rows.length > 3 && (
            <Box
              sx={{ width: "fit-content", float: "right", marginTop: "10px" }}
            >
              <Typography
                sx={{
                  textAlign: "right",
                  fontSize: "calc(0.63rem + var(--large-screen-font-bump))",
                  fontWeight: "bold",
                  color: isNight ? "#eef2f7" : "#CE1126",
                  transition: "color 0.35s ease",
                  display: "inline-block",
                  marginRight: "5px",
                }}
              >
                MORE
              </Typography>
              <img
                src={"Assets/arrow-down-red.svg"}
                alt="arrow-down"
                style={{
                  width: "10px",
                  display: "inline-block",
                  verticalAlign: "middle",
                  filter: isNight ? "brightness(0) invert(1)" : "none",
                  transition: "filter 0.35s ease",
                }}
              />
            </Box>
          )}
        </motion.div>
      ) : (
        <ClickAwayListener onClickAway={() => setExpanded(false)}>
          <motion.div
            layoutId="info-card"
            initial={{ opacity: 0 }}
            animate={{ opacity: show ? 1 : 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            style={{
              ...cardBaseStyles,
              position: "fixed",
              top: "calc(45.5vh - 330px/2)",
              right: "calc(50vw - 650px/2)",
              width: 650,
              height: 330,
              padding: "3vh 2vh 2vh 2vh",
              boxSizing: "border-box",
              zIndex: 1000,
            }}
          >
            <Typography
              fontWeight="bold"
              textAlign={"start"}
              sx={{ fontSize: "calc(0.63rem + var(--large-screen-font-bump))", paddingBottom: "3px" }}
            >
              {data.title}
            </Typography>
            {rowsToShow.map((row, i) => (
              <Box
                key={i}
                display="flex"
                justifyContent="space-between"
                mt={expanded ? 1 : 0.5}
              >
                <span>{row.label}</span> <span>{row.value}</span>
              </Box>
            ))}
            <div style={{ height: "25px" }}></div>
            <Typography
              fontWeight="bold"
              textAlign={"start"}
              sx={{ fontSize: "calc(0.63rem + var(--large-screen-font-bump))", paddingBottom: "3px" }}
            >
              {moreData.title}
            </Typography>
            {moreData.rows.map((row, i) => (
              <Box
                key={i}
                display="flex"
                justifyContent="space-between"
                mt={expanded ? 1 : 0.5}
              >
                <span>{row.label}</span> <span>{row.value}</span>
              </Box>
            ))}
          </motion.div>
        </ClickAwayListener>
      )}
    </>
  );
};
